import React from "react";
import ReactDOM from "react-dom";
import {getShopId} from "../../lib/getShopId";
import {useCustomerSelector} from "../../../store";
import ProductList from "./ProductList";

const ProductListPortal: React.FC = () => {
  const {customerId, customerGroupId, token} = useCustomerSelector().customer;
  const element = document.querySelector<HTMLDivElement>(".product-list-react > div");

  if (!element || !element.parentElement) {
    return null;
  }

  const filtersToShow = element.parentElement.dataset.filtersToShow?.split(",") ?? [];
  const filtersToHide = element.parentElement.dataset.filtersToHide?.split(",") ?? [];
  const defaultFilter = element.parentElement.dataset.defaultFilter;

  const preloader = element.getElementsByClassName("swiper-lazy-preloader")[0];
  if (preloader) element.removeChild(preloader);
  const br = element.getElementsByClassName("clear")[0];
  if (br) element.removeChild(br);

  return ReactDOM.createPortal(
    <ProductList
      shopId={getShopId()}
      categoryId={Number(document.body.id.substring(1))}
      currency={window.c_ActiveCurrency}
      {...{customerId, customerGroupId, token, filtersToShow, filtersToHide, defaultFilter}}
    />,
    element,
  );
};

export default ProductListPortal;
